import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default (function () {
  return /*#__PURE__*/_jsxs("g", {
    children: [/*#__PURE__*/_jsx("circle", {
      className: "line",
      cx: "16",
      cy: "8",
      r: "2.4"
    }), /*#__PURE__*/_jsx("circle", {
      className: "line",
      cx: "16",
      cy: "16",
      r: "2.4"
    }), /*#__PURE__*/_jsx("circle", {
      className: "line",
      cx: "16",
      cy: "24",
      r: "2.4"
    })]
  });
});